import { useQuery } from '@tanstack/react-query';
import { Info, AlertTriangle, Wrench } from 'lucide-react';
import { announcementApi, type Announcement } from '@/services/api';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

const configs: Record<Announcement['type'], {
    bg: string;
    text: string;
    border: string;
    icon: ReactNode;
}> = {
    info: {
        bg: 'bg-[#EFF6FF]',
        text: 'text-[#1D4ED8]',
        border: 'border-[#BFDBFE]',
        icon: <Info className="h-4 w-4 shrink-0" />,
    },
    warning: {
        bg: 'bg-[#FFFBEB]',
        text: 'text-[#92400E] dark:text-[#FDE68A]',
        border: 'border-[#FDE68A]',
        icon: <AlertTriangle className="h-4 w-4 shrink-0" />,
    },
    maintenance: {
        bg: 'bg-[#FEF3C7]',
        text: 'text-[#B45309] dark:text-[#FCD34D]',
        border: 'border-[#FCD34D]',
        icon: <Wrench className="h-4 w-4 shrink-0" />,
    },
};

export function SystemBanner(): ReactNode {
    const { data: announcement } = useQuery({
        queryKey: ['system-announcement'],
        queryFn: announcementApi.get,
        refetchInterval: 2 * 60 * 1000, // polling toutes les 2 minutes
        staleTime: 60 * 1000,
    });

    if (!announcement) return null;

    const config = configs[announcement.type];

    return (
        <div className={cn(
            'flex items-center justify-center gap-2 px-4 py-2.5 border-b text-sm font-medium',
            config.bg, config.text, config.border
        )}>
            {config.icon}
            <span>{announcement.message}</span>
        </div>
    );
}
